var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"transition fade-down","mode":"out-in","appear":""}},[(_vm.name === _vm.panel)?_c('sidebar-panel',{attrs:{"title":_vm.title}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }